import request from '@/utils/request'
export function getTopicList (params) {
  return request({
    url: '/hr/topic/pagePub',
    method: 'GET',
	params
  })
}
// 热门话题
export function gethotTopic () {
  return request({
    url: '/hr/topic/hotTopic',
    method: 'GET',
  })
}
// 动态通知
export function getNotification () {
  return request({
    url: '/hr/topic/officialNotification',
    method: 'GET',
  })
}
export function getDetail (id) {
  return request({
    url: '/hr/topic/info/' + id,
    method: 'GET'
  })
}
// 获取话题分类
export function getTopicType () {
  return request({
    url: '/hr/topictype/fetchAllCommunityType',
    method: 'GET'
  })
}
// 评论列表
export function getCommitList (params) {
  return request({
    url: '/hr/topicreply/page',
    method: 'GET',
	params
  })
}
// 发表评论
export function publishCommit (data) {
  return request({
    url: '/hr/topicreply',
    method: 'POST',
	data
  })
}
// 点赞话题type 0或评论type 1
export function topicUp (data) {
  return request({
    url: '/hr/likerecord',
    method: 'POST',
	data
  })
}

// 收藏话题type 0
export function topicCollect (data) {
  return request({
    url: '/hr/collectionrecord',
    method: 'POST',
	data
  })
}
// 取消收藏
export function cancleCollect (data) {
  return request({
    url: '/hr/collectionrecord/cancel',
    method: 'POST',
	data
  })
}
// 发布话题 isRelease 0草稿 1发布
export function topicCommit (data) {
  return request({
    url: '/hr/topic/commit',
    method: 'POST',
	data
  })
}
// 获取官方案例行业类型
export function getHRCaseIndustryType () {
  return request({
    url: '/sys/dict/type/all/case_industry',
    method: 'GET'
  })
}
// 获取标签top20
export function hotTag () {
  return request({
    url: '/hr/topictag/fetchHotTag',
    method: 'GET'
  })
}
